module.exports = __webpack_public_path__ + "201d0031da36df542566d70a75971f48.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy.svg
// module id = 330
// module chunks = 0